"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBlockchainTokenTickers = exports.isExchangeTicker = exports.isCryptoTicker = exports.isFiatBalanceTicker = exports.isFiatTicker = exports.getBlockchainWithMaxDecimalsByTicker = exports.getBlockchainTickerDecimals = exports.getBlockchainCoin = exports.getTickerBlockchains = exports.getBlockchainTickers = exports.getTokens = exports.getCoinTicker = void 0;
const definitions_1 = require("@ppay/definitions");
const lists_1 = require("./lists");
function getCoinTicker(ticker) {
    var _a, _b;
    return (_b = (_a = lists_1.CryptoTokens.find((ct) => ct.ticker === ticker)) === null || _a === void 0 ? void 0 : _a.coinTicker) !== null && _b !== void 0 ? _b : ticker;
}
exports.getCoinTicker = getCoinTicker;
function getTokens(ticker) {
    return lists_1.CryptoTokens.filter((ct) => ct.coinTicker === ticker).map((ct) => ct.ticker);
}
exports.getTokens = getTokens;
function getBlockchainTickers(blockchain) {
    return lists_1.CryptoCurrencies.filter((v) => v.blockchain === blockchain).map(({ ticker }) => ticker);
}
exports.getBlockchainTickers = getBlockchainTickers;
function getTickerBlockchains(ticker) {
    return lists_1.CryptoCurrencies.filter((c) => c.ticker === ticker).map((c) => c.blockchain);
}
exports.getTickerBlockchains = getTickerBlockchains;
function getBlockchainCoin(blockchain) {
    return lists_1.CryptoCoins.find((c) => c.blockchain === blockchain).ticker;
}
exports.getBlockchainCoin = getBlockchainCoin;
function getBlockchainTickerDecimals(blockchain, ticker) {
    var _a, _b;
    return ((_b = (_a = lists_1.CryptoCurrencies.find((c) => c.blockchain === blockchain && c.ticker === ticker)) === null || _a === void 0 ? void 0 : _a.decimals) !== null && _b !== void 0 ? _b : 0);
}
exports.getBlockchainTickerDecimals = getBlockchainTickerDecimals;
function getBlockchainWithMaxDecimalsByTicker(ticker) {
    const currencies = lists_1.CryptoCurrencies.filter((c) => ticker === c.ticker);
    return currencies.sort((currency1, currency2) => currency2.decimals - currency1.decimals)[0]
        .blockchain;
}
exports.getBlockchainWithMaxDecimalsByTicker = getBlockchainWithMaxDecimalsByTicker;
function isFiatTicker(ticker) {
    return definitions_1.FIAT_TICKERS.includes(ticker);
}
exports.isFiatTicker = isFiatTicker;
function isFiatBalanceTicker(t) {
    return definitions_1.FIAT_BALANCE_TICKERS.includes(t);
}
exports.isFiatBalanceTicker = isFiatBalanceTicker;
function isCryptoTicker(ticker) {
    return definitions_1.CRYPTO_TICKERS.includes(ticker);
}
exports.isCryptoTicker = isCryptoTicker;
function isExchangeTicker(ticker) {
    return definitions_1.EXCHANGE_TICKERS.includes(ticker);
}
exports.isExchangeTicker = isExchangeTicker;
function getBlockchainTokenTickers(blockchain) {
    return lists_1.CryptoTokens.filter((v) => v.blockchain === blockchain).map(({ ticker }) => ticker);
}
exports.getBlockchainTokenTickers = getBlockchainTokenTickers;
